module.exports = __webpack_public_path__ + "static/media/terrain-desert-01.a00c1343.svg";